/**
 * @generated SignedSource<<8066a397d333e45f83fb25e4281af4c4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Inspection_header$data = {
  readonly inspectionfield: {
    readonly externalId: number | null;
    readonly id: string;
    readonly managementPackageSetting: {
      readonly displayNameAlt: string | null;
    } | null;
    readonly member: {
      readonly name: string;
    } | null;
  };
  readonly inspectionform: {
    readonly name: string;
  } | null;
  readonly " $fragmentType": "Inspection_header";
};
export type Inspection_header$key = {
  readonly " $data"?: Inspection_header$data;
  readonly " $fragmentSpreads": FragmentRefs<"Inspection_header">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Inspection_header",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "InspectionFormNode",
      "kind": "LinkedField",
      "name": "inspectionform",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "InspectionfieldNode",
      "kind": "LinkedField",
      "name": "inspectionfield",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "externalId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ManagementPackageSettingsNode",
          "kind": "LinkedField",
          "name": "managementPackageSetting",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayNameAlt",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "MemberNode",
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "InspectionNode",
  "abstractKey": null
};
})();

(node as any).hash = "29e4a2404c4f0929344ad770a393e73c";

export default node;
